import PropTypes from "prop-types";
import React, { Component } from "react";
import Table from "canvas-core-react/lib/Table";
import { withTranslation } from "react-i18next";
import DesktopPagination from "canvas-core-react/lib/DesktopPagination";

export class AdminTable extends Component {
  constructor(props) {
    super(props);
    this.state = { headerSort: [], currentSort: null, loading: false };
  }

  updateData = (data, property = null) => {
    var { headerSort, currentSort } = this.state;
    const { sizePerPage = 5, onTableChange, page } = this.props;

    var loadPage = data.selected;

    if (property !== null) {
      if (headerSort[property] == undefined) {
        headerSort[property] = { order: "ASC" };
      } else {
        let order = headerSort[property].order == "ASC" ? "DESC" : "ASC";
        headerSort[property] = { order: order };
      }
      currentSort = property;
      this.setState({ headerSort, currentSort });
    }

    if (null !== currentSort) {
      if ((null === property && page != loadPage) || null !== property) {
        this.setState({ loading: true });
        onTableChange({
          page: loadPage,
          sizePerPage: sizePerPage,
          sort: headerSort[currentSort].order,
          property: currentSort,
        }).then(() => this.setState({ loading: false }));
      }
    } else if (page != loadPage) {
      this.setState({ loading: true });
      onTableChange({ page: loadPage, sizePerPage: sizePerPage })
        .then(() => {
          this.setState({ loading: false });
        })
        .catch((err) => console.error(err));
    }
  };

  updatePagination = (newPage) => {
    const { sizePerPage = 5, onTableChange, page } = this.props;

    var navPage = newPage - 1;

    if (page != navPage) {
      this.setState({ loading: true });
      onTableChange({ page: navPage, sizePerPage: sizePerPage })
        .then(() => {
          this.setState({ loading: false });
        })
        .catch((err) => console.error(err));
    }
  };

  render() {
    const {
      headers,
      data,
      totalSize,
      sizePerPage = 5,
      actions = null,
      className = "",
      page,
    } = this.props;

    ///const paginatorClassname = null !== actions ? `` : `centered-view`;
    if (undefined !== totalSize) {
      var mod = totalSize % sizePerPage;
      var pageNumber = (totalSize - mod) / sizePerPage;
      pageNumber = mod > 0 ? pageNumber + 1 : pageNumber;
    }

    var currentPage = page + 1;
    let currentClass = `responsive-table ${className}`;

    return (
      <>
        <Table
          columns={headers}
          data={data}
          id={"table"}
          className={currentClass}
          title=""
        />
        {undefined !== totalSize && (actions !== null || pageNumber > 1) && (
          <div
            className={`paginator-container${
              actions !== null && pageNumber <= 1 ? " no-pagination" : ""
            }`}
          >
            {actions}
            {pageNumber >= 1 && (
              <div className="paginator-wrapper">
                <DesktopPagination
                  id="desktop-pagination"
                  totalResultCount={totalSize}
                  className={`pagination-nav`}
                  firstButtonLabel={``}
                  lastButtonLabel={``}
                  prevButtonLabel={``}
                  nextButtonLabel={``}
                  navigationLabel={`Page Navigation`}
                  currentPage={currentPage}
                  pageSize={sizePerPage}
                  onChange={this.updatePagination}
                  containerType={`none`}
                  localizePaginationText={(start, end, totalResultCount) =>
                    `${start} - ${end} de ${totalResultCount}`
                  }
                />
              </div>
            )}
          </div>
        )}
      </>
    );
  }
}

AdminTable.propTypes = {
  headers: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  totalSize: PropTypes.number,
  sizePerPage: PropTypes.number,
  actions: PropTypes.element,
  onTableChange: PropTypes.func,
};

export default withTranslation()(AdminTable);
